import { PlateLeaf } from "@platejs/core/react";
import { withRef } from "@udecode/cn";

export const HighlightLeaf = withRef<typeof PlateLeaf>(
	({ children, ...props }, ref) => (
		<PlateLeaf
			as="mark"
			ref={ref}
			{...props}
			style={{ ...props.style, backgroundColor: "#FEF3B7" }}
		>
			{children}
		</PlateLeaf>
	)
);
